import styled from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';

export const AddOnsPriceContainer = styled.div`
    display: flex;
    align-items: center;
    padding-right: 0.5rem;
    font-size: ${({ theme }) => theme.tokens.BrandTypographyFontSizeBase};
    margin-top: 1rem;
`;

export const AddOnsCheckBoxListWrapper = styled.div`
    .MuiFormGroup-root.checkbox {
        display: block !important;

        @media (min-width: ${BreakPoint.SCREEN_SM_MIN}) {
            column-count: 2;
            column-gap: 1rem;

            .ids-checkbox-list-checkbox-container {
                break-inside: avoid;
                display: inline-block;
                width: 100%;
            }
        }
    }
`;

export const PriceValue = styled.div`
    flex: 1;
    text-align: right;
    font-weight: 500;
`;
